import script from "./PageDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageDetail.vue?vue&type=script&setup=true&lang=ts"

import "./PageDetail.vue?vue&type=style&index=0&id=448c5f1b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-448c5f1b"]])

export default __exports__